import useInView from "./useInView";

export default function Fade({ children, className = '', delay = 0, from = 'bottom' }: { children: React.ReactNode; className?: string; delay?: number; from?: 'bottom' | 'left' | 'right' | 'none'; }) {
    const { ref, inView } = useInView();

    const dx = from === 'left' ? '-24px' : from === 'right' ? '24px' : '0';
    const dy = from === 'bottom' ? '20px' : '0';

    return (
        <div ref={ref} className={className} style={{ opacity: inView ? 1 : 0, transform: inView ? 'translate(0,0)' : `translate(${dx},${dy})`, transition: `opacity 0.75s cubic-bezier(.16,1,.3,1), transform 0.75s cubic-bezier(.16,1,.3,1)`, transitionDelay: `${delay}ms` }}>
            {children}
        </div>
    );
}